import { render } from "./ProductCategoryShowComponent.vue?vue&type=template&id=52fbd6b4"
import script from "./ProductCategoryShowComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductCategory/ProductCategoryShowComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52fbd6b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52fbd6b4', __exports__)) {
    api.reload('52fbd6b4', __exports__)
  }
  
  module.hot.accept("./ProductCategoryShowComponent.vue?vue&type=template&id=52fbd6b4", () => {
    api.rerender('52fbd6b4', render)
  })

}


export default __exports__